import ReportLink from './ReportLink';

export default ReportLink;
